module.exports = __webpack_public_path__ + "static/media/falcon-torch-carrying-case-2.190c44b4.jpg";